import type { ModalData } from '@presentation/components';

type BreederType = {
  breederBreeds: {
    dogBreedId: number;
  }[];
};

export interface MtApplicationsOwnModalControllerData {
  modal: ModalData;
  applicationId: number | undefined;
  breeder: BreederType | null | undefined;
}

export interface MtApplicationsOwnModalControllerProps
  extends MtApplicationsOwnModalControllerData {
  onRedirect(): void;
}
